import { Link } from 'react-router'
import AanvraagFormulier from '../components/AanvraagFormulier'
import {
  IconKlok,
  IconPersoon,
  IconPijl,
  IconSchildVink,
} from '../components/Iconen'

/*
 * P1 — Home. Tekst en opbouw letterlijk uit legacy/current/index.html
 * (CR-01 t/m CR-03, FR-01 t/m FR-09).
 */

const kaarttypen = [
  {
    badge: 'GPK-B',
    kop: 'De bestuurderskaart',
    tekst: 'U bent beperkt in uw loopvermogen, maar kan nog wel autorijden.',
    waarde: 'B',
  },
  {
    badge: 'GPK-P',
    kop: 'De passagierskaart',
    tekst:
      'U bent beperkt in uw loopvermogen en moet van deur tot deur vervoerd worden.',
    waarde: 'P',
  },
  {
    badge: 'GPK-B+P',
    kop: 'De combinatiekaart',
    tekst:
      'U bent beperkt in uw loopvermogen, maar kan afwisselend nog zelf rijden.',
    waarde: 'B+P',
  },
] as const

export default function Home() {
  return (
    <>
      {/* CR-01 */}
      <section className="hero">
        <div className="wrap reveal">
          <span className="eyebrow">BIG-geregistreerde artsen</span>
          <h1>Onafhankelijk sociaal medisch advies</h1>
          <p className="lede">
            Wij helpen gemeenten en cliënten met snelle, onafhankelijke en
            deskundige medische beoordelingen voor gehandicaptenparkeerkaarten
            (GPK). Dankzij onze gespecialiseerde aanpak bieden wij korte
            doorlooptijden, persoonlijk contact en een helder adviesproces.
          </p>
          <div className="hero__cta">
            <a href="#aanvraag" className="btn btn--primary btn--big">
              Vraag direct aan
              <IconPijl />
            </a>
            <Link to="/beoordeling" className="btn btn--ghost">
              Bekijk het stappenplan
            </Link>
          </div>
        </div>
      </section>

      {/* Kernpunten */}
      <section className="section kern" aria-label="Onze kernpunten">
        <div className="wrap">
          <div className="kern__grid">
            <article className="kern__item reveal">
              <span className="kern__ic" aria-hidden="true">
                <IconKlok />
              </span>
              <h2>Snel</h2>
              <p>
                Afspraakbevestiging binnen een week en advies doorgaans binnen
                24 uur na de beoordeling.
              </p>
            </article>
            <article className="kern__item reveal">
              <span className="kern__ic" aria-hidden="true">
                <IconPersoon />
              </span>
              <h2>Persoonlijk</h2>
              <p>
                Direct contact met onze artsen en beoordelingen op locatie, via
                videobellen of aan huis.
              </p>
            </article>
            <article className="kern__item reveal">
              <span className="kern__ic" aria-hidden="true">
                <IconSchildVink />
              </span>
              <h2>Deskundig</h2>
              <p>
                Onafhankelijke medische beoordelingen uitgevoerd door ervaren
                artsen met expertise in het sociaal-medisch domein.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* CR-02 + CR-03 */}
      <section className="section types" id="kaarttypen">
        <div className="wrap">
          <div className="reveal">
            <span className="eyebrow">Voor wie?</span>
            <h2 style={{ fontSize: 'clamp(1.7rem,3vw,2.3rem)' }}>
              Voor wie is een gehandicaptenparkeerkaart?
            </h2>
            <p className="lede" style={{ marginTop: '14px', maxWidth: '42em' }}>
              Kunt u moeilijk lopen en rijdt u auto of moet u vervoerd worden
              door een ander? Dan komt u mogelijk in aanmerking voor een
              gehandicaptenparkeerkaart (GPK). Er bestaan 3 types GPK:
            </p>
          </div>
          <div className="types__grid">
            {kaarttypen.map((kaart) => (
              <article className="type reveal" key={kaart.waarde}>
                <span className="type__badge">{kaart.badge}</span>
                <h3>{kaart.kop}</h3>
                <p>{kaart.tekst}</p>
                {/*
                  FR-03: het kaarttype wordt voorgeselecteerd in het formulier.
                  Het formulier leest dat uit de query-parameter, zodat de keuze
                  ook een deelbare link oplevert en niet verdwijnt bij een
                  herlading.
                */}
                <Link
                  to={`/?kaarttype=${encodeURIComponent(kaart.waarde)}#aanvraag`}
                  className="btn btn--primary"
                >
                  Vraag {kaart.badge} aan
                </Link>
              </article>
            ))}
          </div>
          <p className="types__more reveal">
            Bekijk het volledige <Link to="/beoordeling">stappenplan</Link>.
          </p>
        </div>
      </section>

      {/* FR-04/FR-05: compact aanvraagformulier */}
      <section className="section section--tint aanvraag" id="aanvraag">
        <div className="wrap">
          <div
            className="reveal"
            style={{ textAlign: 'center', maxWidth: '640px', margin: '0 auto' }}
          >
            <span className="eyebrow" style={{ justifyContent: 'center' }}>
              Aanvragen &amp; betalen
            </span>
            <h2 style={{ fontSize: 'clamp(1.7rem,3vw,2.3rem)' }}>
              Vraag uw kaart direct aan
            </h2>
            {/*
              De bestaande site zegt hier "Daarna kiest u een afspraakmoment voor
              de beoordeling". Dat belooft een boekingsstap die v1 niet heeft:
              requirements v1.1 §2 heeft het online plannen geschrapt en FR-12a
              legt vast dat de backoffice het moment mailt. De formulering
              hieronder is die van stap 3 op de beoordelingspagina, waar de
              bestaande site het wél goed zegt.
            */}
            <p className="lede" style={{ marginTop: '14px' }}>
              Vul het formulier in en betaal veilig met iDEAL. Daarna nemen wij
              contact met u op om een afspraakmoment te plannen.
            </p>
          </div>

          <AanvraagFormulier />
        </div>
      </section>
    </>
  )
}
